export const blogData = [
    {
        id: 1,
        title: 'Second place in College Hackathon',
        description: 'Developed warehouse system linking owners and farmers, achieving 30% efficiency.',
        date: '',
        image: '',
        url: ''
    },
    {
        id: 2,
        title: ' 612 LeetCode problems solved',
        description: 'Solved 612 LeetCode problems,by using various data structures and algorithms.',
        date: '',
        image: '',
        url: ''
    },
    {
     id:6,
     title:'Solved 1935 problems on Skillrack',
        description:'Solved 1935 problems on Skillrack, a competitive programming platform.',
        date:'',
        image:'',
        url:''
        
    },
    {
        id: 3,
        title: '3-star coder rating on Codechef',
        description: ' Achieved a 3-star coder rating on Codechef with a 1624 rating.',
        date: '',
        image: '',
        url: ''
    },
    {
        id: 4,
        title: 'Placed 2nd Runner-Up in Novice Coders Hackathon at Ethiraj College',
        description: 'Advanced book interactivity with AR.',
        date: '',
        image: '',
        url: ''
    },
    {
        id: 5,
        title: 'HackFusion finalist',
        description: 'Addressing farmers’ market access with direct supply connections, regional language adaptation.',
        date: '',
        image: '',
        url: ''
    }
]
